import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageContainer, PageTitle } from 'src/modules/common/components/Structure';
import { Analysis as AnalysisContainer } from 'src/modules/analysis';

const Analysis = () => {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <PageTitle title={t('modules.analysis.pageTitle')} />
      <AnalysisContainer />
    </PageContainer>
  );
};

export default Analysis;
